<template>
  <table v-if="scores.length > 0">
    <thead>
    <tr>
      <th class="ranking">{{ $store.getters['getUIText']('rank') }}</th>
      <th>{{ $store.getters['getUIText']('name') }}</th>
      <th class="score">{{ $store.getters['getUIText']('score') }}</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(score, index) in truncateList(scores, 7)" :key="index">
      <td class="ranking">{{index+1}}</td>
      <td class="name">{{score.name}}</td>
      <td class="score">{{score.score}}</td>
    </tr>
    </tbody>
  </table>
  <spinner v-else></spinner>
</template>

<script>
import API from "../assets/js/api";
import Spinner from "./spinner";
export default {
  name: "leaderboard",
  components: {Spinner},
  data(){
    return {
      scores: []
    }
  },
  methods:{
    truncateList(list, length){
      return list.slice(0, length)
    }
  },
  mounted() {
    API.loadScore(undefined,"all").then(response=>{
      console.log(response);
      this.scores = response.data.sort((a,b)=>{
        console.log(a);
        return b.score - a.score;
      });
    })
  }
}
</script>

<style scoped lang="less">
@import (reference) "../assets/less/colors";
table{
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-column-gap: 0;
  text-align: left;
  th, td{
    padding: 0.25rem 0.75rem 0.25rem 0;
  }
}
thead, tbody, tr{
  display: contents;
}
tr:nth-child(even) td{
  background: lighten(@lightgray, 17%);
}
.ranking{
  text-align: right;
}
.score{
  text-align: right;
}
</style>
